import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const buyers = [{
    name: 'Florencia B.',
    city: 'Córdoba',
    product: 'Kit Completo + Autonomía Nocturna 🏆',
    time: '6 minutos'
  }, {
    name: 'Mariana L.',
    city: 'CABA',
    product: 'Kit SOS Nocturno 🌙',
    time: '12 minutos'
  }, {
    name: 'Julieta S.',
    city: 'Rosario',
    product: 'Kit Completo + Autonomía Nocturna 🏆',
    time: '24 minutos'
  }, {
    name: 'Carolina M.',
    city: 'Mendoza',
    product: 'Kit SOS Nocturno 🌙',
    time: '41 minutos'
  }, {
    name: 'Lucía P.',
    city: 'Neuquén',
    product: 'Kit Completo + Autonomía Nocturna 🏆',
    time: '1 hora'
  }];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle logic
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentBuyer(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next
      // Auto hide after 5s
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    }, 15000); // Every 15 seconds start a new cycle
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [buyers.length]);
  return <AnimatePresence data-id="element-229">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto bg-navy-800 border border-navy-600 rounded-xl shadow-2xl p-4 pr-10 flex items-start gap-3" data-id="element-230">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-white transition-colors" data-id="element-231">
            <X className="w-4 h-4" data-id="element-232" />
          </button>

          <div className="mt-1 shrink-0" data-id="element-233">
            <CheckCircle className="w-5 h-5 text-green-400" data-id="element-234" />
          </div>

          <div data-id="element-235">
            <p className="text-xs text-green-400 font-semibold mb-1 uppercase tracking-wider" data-id="element-236">
              Compra verificada
            </p>
            <p className="text-sm text-white leading-tight" data-id="element-237">
              <span className="font-bold" data-id="element-238">{buyers[currentBuyer].name}</span> de{' '}
              {buyers[currentBuyer].city} compró <br data-id="element-239" />
              <span className="text-gold-400 font-medium" data-id="element-240">
                {buyers[currentBuyer].product}
              </span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-241">
              hace {buyers[currentBuyer].time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}